import StoryblokAPIClient from 'storyblok-js-client';
import { shared } from '../config';
import { relations } from './relations';
import { resolveRelations } from './resolver';
import { encodeSVGs } from './svgToBase64';

export class OllieStoryblokClient extends StoryblokAPIClient {
  constructor(redis, oauthToken) {
    super({
      accessToken: shared.STORYBLOK_API_ACCESS_TOKEN,
      oauthToken: oauthToken,
      responseInterceptor: async response => {
        if (response.data.story) {
          response.data.story.content = await resolveRelations(
            response.data.story.fullSlug,
            response.data.story.content,
            async uuid => (await this.getStoryByUUID(uuid)).data.story.content,
            async folder => {
              const {
                data: { stories },
              } = await this.getStoryFolder(folder);
              const result = [];
              for (let key in stories) {
                result.push(
                  await resolveRelations(
                    stories[key].full_slug,
                    stories[key],
                    async uuid =>
                      (
                        await this.getStoryByUUID(uuid)
                      ).data.story.content,
                  ),
                );
              }
              return result;
            },
          );
          response.data.story.content = await encodeSVGs(
            response.data.story.content,
          );
        }

        return response;
      },
    });
    this.redis = redis;
  }

  static HOME_SLUG = 'home';
  static ACCOUNT_SLUG = 'account';

  async getLandingStories() {
    const cacheVersion = await this.getVersion();
    const res = this.getAll('cdn/stories', {
      version: 'published',
      cv: cacheVersion,
      filter_query: {
        component: {
          in: 'landing',
        },
      },
    });
    return res;
  }

  async getStory(fullSlug) {
    const cacheVersion = await this.getVersion();
    const res = await this.get(`cdn/stories/${fullSlug}`, {
      resolve_relations: relations.join(','),
      version: 'published',
      cv: cacheVersion,
    });
    return res;
  }

  async getStoryFolder(fullSlug) {
    const cacheVersion = await this.getVersion();
    const res = await this.get(`cdn/stories?starts_with=${fullSlug}/`, {
      resolve_relations: relations.join(','),
      version: 'published',
      cv: cacheVersion,
    });
    return res;
  }

  async getStoryByUUID(uuid) {
    const cacheVersion = await this.getVersion();
    const res = await this.get(`cdn/stories/${uuid}`, {
      find_by: 'uuid',
      resolve_relations: relations.join(','),
      version: 'published',
      cv: cacheVersion,
    });
    return res;
  }

  async getAsset(spaceId, assetId) {
    const res = await this.get(`spaces/${spaceId}/assets/${assetId}`);
    return res;
  }

  cacheProvider() {
    if (this.redis && shared.STORYBLOK_REDIS_ENABLED) {
      return this.redis;
    }
    return super.cacheProvider();
  }

  async getVersion() {
    if (this.redis) {
      const redisVersion = await this.redis.get('storyblok:version');
      if (redisVersion) return redisVersion;
    }
    const response = await this.get(`cdn/spaces/me`, {
      // this slug does not get cached by get function in storyblok
      params: {
        accessToken: shared.STORYBLOK_API_ACCESS_TOKEN,
      },
    });
    const version = response.data.space.version;
    if (this.redis) {
      await this.redis.set('storyblok:version', version);
    }

    return version;
  }
}
